import React from "react";
import AddLearningForm from "./AddLearningForm";
import { TeamMatesConfig } from "./teamMatesConfig";
import { TaskLabels } from "./types";

export interface CoachFormProps {
  taskLabel: keyof typeof TaskLabels;
  context?: Record<string, unknown>;
  extra?: Record<string, unknown>;
  onClose: (data?: unknown) => void;
}

const CoachForm = (props: CoachFormProps) => {
  const teammate = TeamMatesConfig.find(t => t.key === props.taskLabel);
  if (teammate?.formComponent) {
    // Handle ESM/CJS interop - component might be wrapped in { default: Component }
    const FormComponent =
      typeof teammate.formComponent === "function"
        ? teammate.formComponent
        : (teammate.formComponent as { default: React.ComponentType<CoachFormProps> }).default;

    if (FormComponent) {
      return <FormComponent {...props} />;
    }
  }

  return <AddLearningForm {...props} />;
};

export default CoachForm;
